import React, {
  forwardRef,
  useState,
  useEffect,
  useImperativeHandle,
} from "react";
import { data, useNavigate } from "react-router-dom";
// Components
import { Table, Form, Select, message } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import StepsHeading from "./StepsHeading";
import { AddItemButton, CustomInput, CustomSelect } from "../../../components";
import { AddUsers, GetUsers } from "../../../api's/onboarding";
import { useSpin } from "../../../components/SpinContext.js";
import { useToken, appHelper } from "../../../common/helper";

const { Option } = Select;

const Users = forwardRef(({ onNext, onSuccess }, ref) => {
  const [form] = Form.useForm();
  const { token, removeToken } = useToken();
  const navigate = useNavigate();
  const { showSpin, hideSpin } = useSpin();
  const [dataArr, setDataArr] = useState([]);

  // const [list,setList] = useState([]);

  const res = [
    { key: 1, email: "nisha@g.com", role: "Admin", id: 1 },
    { key: 2, email: "nisha@g.com", role: "Admin", id: 1 },
  ];

  const onFinish = (values) => {
    // console.log("Product Info:", values);
    // onNext();
  };

  // const primaryCallback = (a,callback) =>{
  //   if(a){
  //     callback();
  //   }
  // }

  const fetchUsers = () => {
    setDataArr([]);
    showSpin();
    GetUsers(token, false)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let arr = data?.data?.data.length > 0 ? data?.data?.data : [];
            if (arr.length > 0) {
              let newData = arr.map((element, index) => ({
                key: (index + 1).toString(), // Generate unique keys based on the current data length
                email: element.email || "",
                role: element?.teams?.find(x=>x.name.toLowerCase() === "default").role_name || "",
                id: element.id || null,
              }));
              setDataArr(newData);
            } else {
              setDataArr([
                {
                  id: null,
                  email: "",
                  role: "",
                  key: "1",
                },
              ]);
            }
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleInputChange = (key, event) => {
    setDataArr((prev) =>
      prev.map((item) =>
        item.key === key ? { ...item, email: event.target.value } : item
      )
    );
  };

  const handleSelectChange = (key, value) => {
    setDataArr((prev) =>
      prev.map((item) => (item.key === key ? { ...item, role: value } : item))
    );
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const submitUsers = (model) => {
    AddUsers(token, model, false)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            onSuccess();
            // message.success(data?.data?.message);
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  //Expose specific methods to the parent through useImperativeHandle
  useImperativeHandle(ref, () => ({
    completeStep, // Expose the submitProducts method to the parent
  }));

  const completeStep = () => {
    form
      .validateFields()
      .then(() => {
        const values = form.getFieldsValue();
        const formattedData = Object.keys(values).map((key) => ({
          key,
          email: values[key].email,
          role: values[key].role || "Admin", // fallback just in case
          id: dataArr.find((item) => item.key === key)?.id || null,
        }));
  
        if (formattedData.length > 0) {
          submitUsers(formattedData);
        } else {
          message.error("Please invite at least one person from your organization.");
        }
      })
      .catch((err) => {});
  };

  
  // const completeStep = () => {
  //   form
  //     .validateFields()
  //     .then((values) => {
  //       if (values && Object.keys(values).length > 0) {
  //         //for the sake every thing must be in the list is valid
  //         if (dataArr && dataArr.length > 0) {
  //           submitUsers(dataArr);
  //         }
  //       } else {
  //         message.error(
  //           "Please invite at least one person from your organization."
  //         );
  //       }
  //     })
  //     .catch((err) => {});
  // };

  const handleDeleteRow = (key) => {
    setDataArr((prev) => prev.filter((item) => item.key !== key));
    form.resetFields([[key, "email"], [key, "role"]]);
  };
  
  const handleAddItem = () => {
    const newKey = Date.now().toString();
    const newItem = {
      key: newKey,
      email: "",
      role: "",
    };
    setDataArr((prev) => [...prev, newItem]);
  };
  
  const columns = [
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      render: (_, record,index) => (
        <Form.Item
          name={[record.key, "email"]}
          initialValue={record.email}
          rules={[
            { required: true, message: "Please enter your email" },
            { type: "email", message: "Enter Valid Email Only" },
          ]}
          style={{ marginBottom: "0px" }}
        >
          <CustomInput
            placeholder="Enter email"
            height="36px"
            border={index === 0 ? "2px solid #E8E8E8":"0px"}
            bgColor={index === 0 ? "#fff":"#F3F3F3"}
            textColor="#5E5E5E"
            borderRadius="8px"
            disabled={index === 0}
            placeholderColor="#5E5E5E"
            lineHeight="38px"
            onChange={(value) => handleInputChange(record.key, value)}
          />
        </Form.Item>
      ),
    },
    {
      title: "Permission level",
      dataIndex: "role",
      key: "role",
      render: (_, record,index) => (
        <Form.Item
          name={[record.key, "role"]}
          initialValue={record.role || (index===0 ? 'Admin' : '' )}
          rules={[{ required: true, message: "Please select option" }]}
          style={{ marginBottom: "0" }}
        >
          <CustomSelect
            placeholder="Select"
            onChange={(value) => handleSelectChange(record.key, value)}
            width="100%"
            height="36px"
            className="custom-select-disabled"
            border={index === 0 ? "2px solid #E8E8E8":"0px"}
            bgColor={index === 0 ? "#fff":"#F3F3F3"}
            disabled={index === 0}
            textColor="#5E5E5E"
            borderRadius="8px"

            disableOption={true}
            optionName='Admin'

            options={[
              { value: "Admin", label: "Admin" },
              { value: "Member", label: "Member" },
              { value: "Viewer", label: "Viewer" },
            ]}
            // options={[
            //   { value: "Viewer", label: "View only" },
            //   { value: "Editor", label: "Edit" },
            //   { value: "Admin", label: "Admin" }
            // ]}
          />
        </Form.Item>
      ),
    },
    {
      key: "action",
      render: (_, record, index) => (
        <div
          onClick={() => {
            if (index !== 0) handleDeleteRow(record.key);
          }}
          style={{
            cursor: index === 0 ? "not-allowed" : "pointer",
            opacity: index === 0 ? 0.4 : 1,
          }}
        >
          <CloseOutlined />
        </div>
      ),
    }
    
  ];

  return (
    <>
      <div style={{ paddingBottom: "20px" }}>
        <div className="default-steps-content">
          <StepsHeading
            heading="Invite people from your organization"
            text="Invite your teammates to join your organization on ZoomLogi. They will be able to see all shipments being tracked by your linked couriers."
          />
          <Form form={form} name="users" layout="vertical" onFinish={onFinish}>
            <Table
              columns={columns}
              dataSource={dataArr}
              pagination={false}
              rowKey="key"
              className="custom-table"
              rowHoverable={false}
            />

            <AddItemButton text="Add Another" onClick={handleAddItem} />
          </Form>
        </div>
      </div>
    </>
  );
});

export default Users;
